import React from 'react'
import styled from 'styled-components'
import { Scalars } from 'types/graphql'
import { ContentBoxTitle } from 'lib/ContentBox'
import { Text } from 'lib/Text'
import { Story } from 'modules/stories/components/Story'
import { useBrandStories } from '../queries/brandStories'

const StoryRow = styled(Story)`
  border-bottom: none;
  padding-left: 0;

  &:last-child {
    margin-bottom: 0;
  }
`

const Stories = styled.div``

const NoStories = styled(Text)`
  background: var(--neutral-10);
  border-left: 4px solid var(--neutral-80);
  padding: 16px 20px;
  position: relative;
  margin-bottom: 24px;
`

interface Props {
  brandId: Scalars['ID']
  brandTitle: string
}
export const RelatedStories = ({ brandId, brandTitle }: Props) => {
  const { data } = useBrandStories(brandId)

  if (!data?.brand) {
    return null
  }

  if (data.brand.stories.length === 0) {
    return (
      <NoStories size="ps" weight="semi">
        {brandTitle} hasn't been featured in any stories yet.
      </NoStories>
    )
  }

  return (
    <>
      <ContentBoxTitle>{brandTitle} featured on Thingtesting</ContentBoxTitle>

      <Stories>
        {data.brand.stories.map((story) => (
          <div data-nosnippet key={story.id}>
            <StoryRow key={story.id} story={story} />
          </div>
        ))}
      </Stories>
    </>
  )
}
